import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";


const JavaScriptLesson15 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>Operators</strong></h3>
    <p>JavaScript operators are symbols used to perform operations on operands, which can be values or variables. They allow you to perform arithmetic, assignment, comparison, logical, and other operations. </p>
      <p>JavaScript supports the following types of operators</p>
      <ol class="list-group list-group-numbered">
        <li class="list-group-item">Arithmetic operators</li>
        <li class="list-group-item">Comparison operators</li>
        <li class="list-group-item">Logical (Relational) operators</li>
        <li class="list-group-item">Assignment operators</li>
        <li class="list-group-item">Conditional (Ternary) operators </li>
      </ol>
      <div style={{ height: 450 }} />
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson15
